import moment from 'moment';
import {isSpanishLocale} from '@constants/languages';
import i18next from 'i18next';

/** Moment format strings for admin list dates. */
export const getLocalizedDateFormat = (language = i18next.language) =>
  isSpanishLocale(language) ? 'DD-MM-YYYY' : 'MM-DD-YYYY';

export const formatLocalizedDate = (value, language = i18next.language) => {
  if (!value) {
    return '';
  }
  return moment(value).format(getLocalizedDateFormat(language));
};
